import comp from "./PromptCards";
export default comp;
